import type {ReactElement} from 'react';
import {isUnderSignupForm} from './is-under-signup-form';
import type {SignupOnlyProps} from './signup-only.types';

export function SignupOnly({component, children}: SignupOnlyProps): ReactElement | null {
  if (!isUnderSignupForm(component)) {
    return null;
  }
  return <>{children}</>;
}
